import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Card,           // --- ADDED ---
    CardContent,    // --- ADDED ---
    Button,         // --- ADDED ---
    CircularProgress, // --- ADDED ---
    Alert           // --- ADDED ---
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useParams, useNavigate } from "react-router-dom"; // --- ADDED useNavigate ---
import axios from "axios";
import AthleteProfile from "../components/athlete/AthleteProfile";
import AthleteCredits from "../components/athlete/AthleteCredits";
import AthletePlan from "../components/athlete/AthletePlan";
import AthleteReservations from "../components/athlete/AthleteReservations";
import AthleteCheckins from "../components/athlete/AthleteCheckins";
import Footer from "../components/Footer/Footer";
import WarningIcon from '@mui/icons-material/Warning'; // --- ADDED ---

const OverviewContainer = styled(Box)({
    padding: "2rem",
    backgroundColor: "#1c1c1c",
    color: "#fff",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
});

// --- NEW COMPONENT FOR DELETION CARD ---
const DeletionCard = styled(Card)({
    backgroundColor: 'rgba(255, 23, 68, 0.1)',
    border: '1px solid #ff1744',
    color: '#fff',
    marginBottom: '1rem',
});

const Athlete = () => {
    const { firebaseUid } = useParams();
    const navigate = useNavigate(); // --- ADDED NAVIGATE HOOK ---
    const [athlete, setAthlete] = useState(null);
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(true);

    // --- NEW STATE FOR DELETION ---
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState(null);
    const [deleteSuccess, setDeleteSuccess] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/user/profile/${firebaseUid}`)
            .then((response) => {
                setAthlete(response.data.user);
                setReservations(response.data.reservations);
            })
            .catch((err) => {
                console.error("Error fetching athlete data:", err);
                if (err.response && err.response.status === 404) {
                    setAthlete(null);
                }
            })
            .finally(() => setLoading(false));
    }, [firebaseUid]);

    // --- NEW HANDLER FOR DELETION ---
    const handleConfirmDeletion = async () => {
        setDeleteError(null);
        setDeleteSuccess(null);

        if (!window.confirm("Are you sure? This will send the final confirmation email and permanently delete the user from all systems.")) {
            return;
        }

        setIsDeleting(true);

        try {
            // This calls the new route: /api/user/:firebaseUid/confirm-deletion
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/user/${firebaseUid}/confirm-deletion`
            );

            setDeleteSuccess(response.data.message || 'User has been notified and deleted.');

            // After 3 seconds, redirect back to the athletes list
            setTimeout(() => {
                navigate('/athletes'); // Make sure this is your correct route
            }, 3000);

        } catch (error) {
            console.error("Error confirming deletion:", error);
            setDeleteError(error.response?.data?.message || 'Failed to delete user.');
            setIsDeleting(false);
        }
    };

    if (loading) return <Typography>Loading...</Typography>;
    // Handle case where user is not found (e.g., already deleted)
    if (!athlete) return <Typography sx={{ color: 'white', padding: '2rem' }}>Athlete not found.</Typography>;

    return (
        <OverviewContainer>
            <Typography variant="h4">Athlete Overview</Typography>

            {/* --- NEW DELETION CARD RENDER --- */}
            {athlete.deletionRequested && (
                <DeletionCard>
                    <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <WarningIcon color="error" sx={{ mr: 1 }} />
                            <Typography variant="h6" component="div" color="error">
                                Account Deletion Requested
                            </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ mb: 2, color: '#eee' }}>
                            This user has requested to delete their account. Clicking the button below will send them a final confirmation email and permanently delete their data from all systems (Stripe, Firebase, Memberful, and Mongo).
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 2, color: '#eee' }}>
                            Confirmation Email will be sent to: <strong>{athlete.deletionConfirmationEmail || athlete.email}</strong>
                        </Typography>

                        {deleteSuccess && <Alert severity="success" sx={{ mb: 2 }}>{deleteSuccess}</Alert>}
                        {deleteError && <Alert severity="error" sx={{ mb: 2 }}>{deleteError}</Alert>}

                        <Button
                            variant="contained"
                            color="error"
                            disabled={isDeleting || !!deleteSuccess}
                            onClick={handleConfirmDeletion}
                            startIcon={isDeleting ? <CircularProgress size={20} color="inherit" /> : null}
                        >
                            {isDeleting ? 'Processing...' : 'Confirm & Notify Deletion'}
                        </Button>
                    </CardContent>
                </DeletionCard>
            )}
            {/* --- END OF NEW CARD --- */}

            {/* ✅ Athlete Profile */}
            <AthleteProfile athlete={athlete} />

            {/* ✅ Athlete Credits */}
            <AthleteCredits firebaseUid={firebaseUid} athlete={athlete} setAthlete={setAthlete} />

            {/* ✅ Athlete Plan */}
            <AthletePlan planDetails={athlete.planDetails} />

            {/* ✅ Athlete Reservations */}
            <AthleteReservations reservations={reservations} />

            {/* ✅ Athlete Check-ins */}
            <AthleteCheckins firebaseUid={firebaseUid} />

            <Footer />
        </OverviewContainer>
    );
};

export default Athlete;